import { Box, IconButton, Tooltip } from "@mui/material";
import { FC } from "react";
import { useNavigate } from "react-router-dom";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

export type TableActionsProps = {
  editUrl?: string;
  deleteCallback?: () => void;
  showDelete?: boolean;
}

const TableActions: FC<TableActionsProps> = ({editUrl, deleteCallback, showDelete = true}) => {
  const navigate = useNavigate();

  return (
    <Box>
      {Boolean(editUrl) && (
        <Tooltip title="Editar">
          <IconButton
            size="small"
            onClick={(event) => {
              event.stopPropagation();
              navigate(editUrl ?? '/');
            }}
          >
            <EditIcon />
          </IconButton>
        </Tooltip>
      )}
      {(Boolean(deleteCallback) && showDelete) && (
        <>
          <Tooltip title="Apagar">
          <IconButton
            size="small"
            onClick={(event) => {
              event.stopPropagation();
              deleteCallback?.();
            }}
          >
            <DeleteIcon />
          </IconButton>
        </Tooltip>
        </>
      )}
    </Box>
  )
}

export default TableActions;
